export default "__VITE_ASSET__BdbvfSsf__"